import { styled } from 'styled-system/jsx'

const PageShell = styled('main', {
  base: {
    minHeight: '100vh',
    backgroundColor: 'app.bg',
    color: 'app.fg',
    paddingX: { base: '16px', md: '32px' },
    paddingY: { base: '24px', md: '48px' },
    display: 'flex',
    justifyContent: 'center',
  },
})

const Centered = styled('div', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    color: 'app.fgMuted',
    paddingY: '64px',
    textAlign: 'center',
    maxWidth: '480px',
  },
})

const ErrorState = styled('div', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    color: 'book.danger',
    paddingY: '64px',
    maxWidth: '480px',
    textAlign: 'center',
  },
})

const Card = styled('div', {
  base: {
    width: '100%',
    maxWidth: '720px',
    backgroundColor: 'app.surface',
    borderRadius: 'lg',
    border: '1px solid',
    borderColor: 'app.border',
    boxShadow: '0 1px 2px rgba(15, 23, 42, 0.04), 0 8px 24px rgba(15, 23, 42, 0.06)',
    padding: { base: '24px', md: '32px' },
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
})

const Heading = styled('h1', {
  base: {
    fontFamily: 'display',
    fontSize: { base: '22px', md: '28px' },
    fontWeight: 600,
    margin: 0,
  },
})

const ExistingBookingPanel = styled('div', {
  base: {
    border: '1px solid',
    borderColor: 'app.border',
    borderRadius: 'md',
    padding: '14px 16px',
    backgroundColor: 'book.surfaceMuted',
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    fontFamily: 'body',
    fontSize: '13px',
    color: 'app.fgMuted',
  },
})

const ExistingBookingLabel = styled('div', {
  base: {
    fontWeight: 600,
    color: 'app.fg',
    fontSize: '12px',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
})

const ExistingBookingValue = styled('div', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    color: 'app.fg',
  },
})

export {
  PageShell,
  Centered,
  ErrorState,
  Card,
  Heading,
  ExistingBookingPanel,
  ExistingBookingLabel,
  ExistingBookingValue,
}
